// Poonam's public channels, shown as icons at the top of the site, in the home page hero and in the footer, so visitors
// can see she is real. These four are the ones already published on the About page.
//
// FACEBOOK: add the page address to `href` below and the icon appears everywhere at once. Nothing is shown while it is
// empty, because a made-up address would send visitors to the wrong place.
export const SOCIAL_LINKS = [
  { id: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/satyamshaktiastroandmore/' },
  { id: 'linkedin', label: 'LinkedIn', href: 'https://in.linkedin.com/in/poonam-dutta' },
  { id: 'facebook', label: 'Facebook', href: '' },
  { id: 'youtube', label: 'YouTube', href: 'https://www.youtube.com/channel/UCvhh18ZLBBxNuQSrLvgngXA' },
  { id: 'x', label: 'X', href: 'https://x.com/Satyamshakti9' },
].filter((item) => item.href);
